import { observable } from '@legendapp/state';

interface ZoomStore {
	zoomRanges: [number, number, number];
	zoomLevel: number | null;
	zoomLimit: number | null;
	isZoomed: boolean;
}

const ZOOM_DELTA = 0.2;
const MAX_ZOOM_LEVEL = 1.4;
const MIN_ZOOM_LEVEL = 1;

export const zoomStore = observable<ZoomStore>({
	zoomRanges: (): [number, number, number] => [MIN_ZOOM_LEVEL, MAX_ZOOM_LEVEL, ZOOM_DELTA],
	zoomLevel: null,
	zoomLimit: null,
	isZoomed: false
});

// set isZoomed here
zoomStore.zoomLevel.onChange(() =>
	zoomStore.isZoomed.set(zoomStore.zoomLevel.get()! > MIN_ZOOM_LEVEL + ZOOM_DELTA - 0.2)
);

export const zoomStoreActions = {
	setZoomLevel: (zoomLevel: number) => {
		zoomStore.zoomLevel.set(zoomLevel);
	},
	setZoomLimit: (zoomLimit: number) => {
		zoomStore.zoomLimit.set(zoomLimit);
	},
	resetZoom: () => {
		zoomStore.zoomLevel.set(1);
		zoomStore.zoomLimit.set(-1);
	},
	toggleOneStepZoom: () => {
		if (zoomStore.isZoomed.get()) {
			zoomStoreActions.resetZoom();
			return;
		}

		const [, maxZoomLevel] = zoomStore.zoomRanges.get();
		zoomStore.zoomLimit.set(1);
		zoomStore.zoomLevel.set(maxZoomLevel);
	}
};
